import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const CTABand = () => (
  <section className="relative overflow-hidden bg-brand-graphite" data-testid="cta-band">
    <div
      className="v-accent pointer-events-none absolute left-0 top-0 h-full w-1 bg-brand-red"
      aria-hidden="true"
    />
    <div
      className="pointer-events-none absolute -right-10 -top-10 h-48 w-48 bg-brand-red/15 [clip-path:polygon(100%_0,0_0,100%_100%)]"
      aria-hidden="true"
    />
    <div className="container-site flex flex-col items-start justify-between gap-8 py-20 lg:flex-row lg:items-center lg:py-24">
      <div className="max-w-2xl">
        <p className="eyebrow">Get Started</p>
        <h2 className="mt-3 text-3xl font-semibold text-white sm:text-4xl">
          Let&rsquo;s Build What&rsquo;s Next.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-neutral-400 md:text-lg">
          Tell us about your business challenge, product idea or technology requirement.
        </p>
      </div>
      <Link
        to="/contact?intent=project"
        className="btn-primary shrink-0"
        data-testid="cta-discuss-project-button"
      >
        Discuss Your Project
        <ArrowRight className="h-4 w-4" aria-hidden="true" />
      </Link>
    </div>
  </section>
);

export default CTABand;
